import { bannerTypes } from "@/context/bannerContext"
import { useNav } from "@/context/navContext"
import { mediaUrl } from "@/util/util"

export default function TopBanner({ bannerUrl }: { bannerUrl: bannerTypes | undefined }) {
    const { movePage } = useNav()
    return (
        bannerUrl
        && bannerUrl.image_url
        && <>
            <div className="top-banner">
                <img src={mediaUrl(bannerUrl.image_url)}
                    alt="top-banner"
                    className={`top-banner ${bannerUrl.redirect_url ? '--pointer' : ''}`}
                    onClick={e => {
                        if (bannerUrl.redirect_url)
                            movePage(bannerUrl.redirect_url)
                    }}
                    onError={e => { e.currentTarget.style.display = 'none' }}
                />
            </div>
        </>
    )
}